import { createContext, useContext, useState } from "react";

/**
 * Neo Prompt (Sep 18 2026) — automatic context handoff between whichever lead card a rep has
 * open and Nia in the sidebar. No button on the card; Nia just already knows who she's looking at.
 */
const LeadFocusContext = createContext(null);

export function LeadFocusProvider({ children }) {
  const [focusedLead, setFocusedLead] = useState(null);
  return (
    <LeadFocusContext.Provider value={{ focusedLead, setFocusedLead }}>
      {children}
    </LeadFocusContext.Provider>
  );
}

export function useLeadFocus() {
  return useContext(LeadFocusContext) || {};
}
